const STEM_REGEX = /[甲乙丙丁戊己庚辛壬癸]/gu;

const extractStemChars = (text: string): string[] => {
  const matches = String(text || '').match(STEM_REGEX) || [];
  return Array.from(new Set(matches));
};

const extractXunShouTailStem = (xunShou: string): string => {
  const stems = extractStemChars(xunShou);
  if (stems[0] !== '甲') return '';
  return stems[stems.length - 1] || '';
};

export interface BuildChartJiaValueFuHintParams {
  xunShou?: string;
  zhiFu?: string;
  zhiFuPalaceLabel?: string;
  fourGangPillars?: string[];
}

export function buildChartJiaValueFuHint(params: BuildChartJiaValueFuHintParams): string {
  const xunShou = String(params.xunShou || '').trim();
  const zhiFu = String(params.zhiFu || '').trim() || '值符';
  const zhiFuPalaceLabel = String(params.zhiFuPalaceLabel || '').trim();
  const fourGangPillars = Array.isArray(params.fourGangPillars) ? params.fourGangPillars : [];
  const xunShouTailStem = extractXunShouTailStem(xunShou);
  const fourGangHasJia = fourGangPillars.some((pillar) => extractStemChars(String(pillar || ''))[0] === '甲');
  const scopeText = fourGangHasJia ? '四纲或其他判断对象' : '判断对象';
  const parts = [
    `甲值符归一提示：本盘值符为${zhiFu}${zhiFuPalaceLabel ? `，值符宫在${zhiFuPalaceLabel}` : ''}`,
    `若${scopeText}出现甲，一律按值符处理`,
  ];
  if (xunShou && xunShouTailStem) {
    parts.push(`旬首“${xunShou}”里的“${xunShouTailStem}”仅作旬首配干信息，甲仍归值符，不随旬首尾干改判`);
  }
  return `${parts.join('；')}。`;
}

export interface FormatChartOpenLeadLineParams {
  sourceLabel: string;
  harmLabel: string;
  stem: string;
  targetLabels: string[];
}

export function formatChartOpenLeadLine(params: FormatChartOpenLeadLineParams): string {
  const sourceLabel = String(params.sourceLabel || '').trim() || '目标宫';
  const harmLabel = String(params.harmLabel || '').trim() || '四害';
  const stem = String(params.stem || '').trim() || '-';
  const targetLabels = Array.isArray(params.targetLabels)
    ? params.targetLabels.map((item) => String(item || '').trim()).filter(Boolean)
    : [];
  const prefix = `${sourceLabel}（${harmLabel}）受害干=${stem}`;
  if (targetLabels.length === 0) {
    return `${prefix}：未找到引干同干宫。`;
  }
  return `${prefix}：打开引干看 ${targetLabels.join('、')}`;
}

export function formatChartLeadStemLabel(leadStem: string): string {
  const normalized = String(leadStem || '').trim();
  return `引干${normalized || '-'}`;
}
